<footer
  class="footer"
  *ngIf="!loading"
>

  <div class="footer-container">


    <!-- BRAND -->

    <div class="footer-brand">

      <h2>
        {{
          footer?.brandTitle ||
          'Super Bangladesh'
        }}
      </h2>


      <p>
        {{
          footer?.description ||
          t('footerDescription')
        }}
      </p>


      <div class="social-links">


        <a
          *ngIf="footer?.facebookUrl"
          [href]="footer.facebookUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          f
        </a>


        <a
          *ngIf="footer?.youtubeUrl"
          [href]="footer.youtubeUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          ▶
        </a>


        <a
          *ngIf="footer?.instagramUrl"
          [href]="footer.instagramUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          ◎
        </a>

      </div>

    </div>


    <!-- CUSTOMER SERVICE -->

    <div class="footer-column">

      <h3>
        {{
          footer?.customerServiceTitle ||
          t('customerService')
        }}
      </h3>


      <a
        [href]="
          footer?.helpCenterUrl ||
          '#'
        "
      >
        {{
          footer?.helpCenterText ||
          t('helpCenter')
        }}
      </a>


      <a
        [href]="
          footer?.contactUrl ||
          '#'
        "
      >
        {{
          footer?.contactText ||
          t('contactUs')
        }}
      </a>


      <a
        [href]="
          footer?.reportProblemUrl ||
          '#'
        "
      >
        {{
          footer?.reportProblemText ||
          t('reportProblem')
        }}
      </a>


      <a
        [href]="
          footer?.returnPolicyUrl ||
          '#'
        "
      >
        {{
          footer?.returnPolicyText ||
          t('returnPolicy')
        }}
      </a>

    </div>


    <!-- ABOUT -->

    <div class="footer-column">

      <h3>
        {{
          footer?.aboutTitle ||
          t('aboutSuperBangladesh')
        }}
      </h3>


      <a
        [href]="
          footer?.aboutUsUrl ||
          '#'
        "
      >
        {{
          footer?.aboutUsText ||
          t('aboutUs')
        }}
      </a>


      <a
        [href]="
          footer?.careersUrl ||
          '#'
        "
      >
        {{
          footer?.careersText ||
          t('careers')
        }}
      </a>


      <a
        [href]="
          footer?.termsUrl ||
          '#'
        "
      >
        {{
          footer?.termsText ||
          t('termsConditions')
        }}
      </a>


      <a
        [href]="
          footer?.privacyUrl ||
          '#'
        "
      >
        {{
          footer?.privacyText ||
          t('privacyPolicy')
        }}
      </a>

    </div>


    <!-- CONTACT -->

    <div class="footer-column">

      <h3>
        {{
          footer?.contactTitle ||
          t('contactUs')
        }}
      </h3>


      <p>
        📍
        {{
          footer?.address ||
          t('dhakaBangladesh')
        }}
      </p>


      <p>
        📞
        {{
          footer?.phone ||
          '09600-000000'
        }}
      </p>


      <p>
        ✉
        {{
          footer?.email ||
          'support@superbangladesh.com'
        }}
      </p>


      <p>
        🕒
        {{
          footer?.openingHours ||
          t('open247')
        }}
      </p>

    </div>

  </div>


  <!-- BOTTOM -->

  <div class="footer-bottom">

    <p>
      {{
        footer?.copyrightText ||
        t('allRightsReserved')
      }}
    </p>


    <div class="payment-methods">

      <span
        *ngFor="
          let payment
          of getPaymentMethods()
        "
      >
        {{ payment }}
      </span>

    </div>

  </div>

</footer>